import {
  DashboardContainerHeader,
  ScrollContainer,
} from 'app/layout/dashboardLayout/BoxLayout';
import React from 'react';
import { useAuth } from 'utils/AuthProvider';
import YoutubeEmbed from './shared/YoutubeEmbed';

export default function VideosSection() {
  return (
    <div className="border border-gray-100 max-h-[400px] rounded-md w-full h-full flex flex-col overflow-hidden">
      <div className="border-gray-100 h-[55px] border-b bg-white p-2 flex gap-2 text-sm items-center text-gray-dark font-semibold">
        Get Started
      </div>

      <div className="bg-black h-full flex-1 overflow-auto p-4">
        <div className="flex flex-row gap-4 w-full h-full">
          <div className="flex-1 max-w-[50%] rounded-md overflow-hidden border border-gray-300">
            <iframe
              width="100%"
              height="100%"
              className="aspect-video"
              src="https://www.youtube.com/embed/e7czEtXIW5s"
              title="YouTube video player 1"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            />
          </div>
          <div className="flex-1 max-w-[50%] rounded-md overflow-hidden border border-gray-300">
            <iframe
              width="100%"
              height="100%"
              className="aspect-video"
              src="https://www.youtube.com/embed/pTwtG-09a28" // Replace with the second video ID
              title="YouTube video player 2"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            />
          </div>
        </div>
      </div>
    </div>
  );
}
